var productSelect = document.querySelector('select#Product');
if (productSelect && productSelect.value) {
    var productLabel = productSelect.parentNode.querySelector('label'),
        productText = document.createElement('div');
    productText.setAttribute('id', 'Product_text');
    productText.style.lineHeight = "36px";
    productText.innerText = productSelect.querySelector('[selected]').textContent;
    var productChange = document.createElement('button');
    if (document.documentElement.lang === 'de') {
        productChange.innerText = 'Ändern';
    } else if (document.documentElement.lang === 'es') {
        productChange.innerText = 'Cambiar';
    } else if (document.documentElement.lang === 'fr') {
        productChange.innerText = 'Changer';
    } else if (document.documentElement.lang === 'pt-br') {
        productChange.innerText = 'Alterar';
    } else if (document.documentElement.lang === 'ru') {
        productChange.innerText = 'Изменить';
    } else if (document.documentElement.lang === 'ko') {
        productChange.innerText = '변경하기';
    } else if (document.documentElement.lang === 'ja') {
        productChange.innerText = '他の装置を選択する';
    } else if (document.documentElement.lang === 'zh-cn') {
        productChange.innerText = '更改';
    } else {
        productChange.innerText = 'Change';
    }
    productChange.className = 'u-link u-step--2 u-margin-left-2xs';
    productChange.onclick = function (e) {
        e.preventDefault();
        document.querySelector('select#Product').style.display = 'block';
        document.getElementById('Product_text').remove();
    };
    productText.appendChild(productChange);
    var hideProductChosen = document.createElement('style');
    hideProductChosen.innerHTML = '#Product.c-input {display: none;}';
    document.getElementsByTagName('head')[0].appendChild(hideProductChosen);
    productLabel.parentNode.insertBefore(productText, productLabel.nextSibling);
}